export default __webpack_public_path__ + "static/media/hills.ada4d3d2.svg";